import React, { useEffect } from "react";
import TestimonialImage from '../../assets/Images/TestinomailImages/Image1.webp';


/* AOS LIBRARY */
import AOS from 'aos';
import 'aos/dist/aos.css';

/* SCSS LINK */
import '../Testimonial/Testimonial.scss';

/* ICONS LIKS */
import { IoStarSharp } from "react-icons/io5";

function Testimonial() {


    /* AOS  */
    useEffect(() => {
        AOS.init();
    }, [])




    return (

        <>
            <div className="testimonail_section">

                <div className="image">
                    <img className='w-100' src={TestimonialImage} />
                </div>
                <div className='text'>

                    <div className='start_icons'>
                        <IoStarSharp className='fs-2 icon' />
                        <IoStarSharp className='fs-2 icon' />
                        <IoStarSharp className='fs-2 icon' />
                        <IoStarSharp className='fs-2 icon' />
                        <IoStarSharp className='fs-2 icon' />
                    </div><br />

                    <h1>Khushboo Bhatia</h1>
                    <h3>Corporate communication manager Asia Pacific</h3>
                    <div className='rating'>
                        <p>I like to be lite and effortless at work. The RASHKI Chique is compact and minimal but yet has a place for everything I need in my day.</p>
                    </div>
                </div>
            </div>


            {/*  Know more */}
            <div className='Testimonial_KnowMore_Text'>
                <div className='text'>
                    <p>We understand that you have a lot on your plate, together let’s #accomplishmore</p>

                    <p><a href='https://rashki.com/pages/about-us'>Know More</a></p>
                </div>
            </div>

        </>
    )
}

export default Testimonial;